'use strict';
var base = require('./base');
var customerservice = require('../pages/customerservice');
var interID;
var varCounter = 0;
var varCounter2 = 0;
var powerReview = require('../product/powerReview');

var loadMiraklOffers = require('mirakl/product/loadMiraklOffers');

/**
 * Populates the mirakl offers section on pdp
 */
loadMiraklOffers.loadMiraklOffers = function loadMiraklOffers() {
  var miraklOffersJson = $('.js-mirakl-offers-json').data('mirakloffers');
  var url = $('.js-mirakl-offers-json').data('url');

  if (typeof miraklOffersJson !== 'undefined' && miraklOffersJson.length) {
      $.ajax({
          url: url,
          type: 'post',
          data: { miraklOffersJson: JSON.stringify(miraklOffersJson) },
          success: function (data) {
              if (data.offersHtml !== '') {
                  $('.mirakl-offer-list').html(data.offersHtml);
              } else {
                  $('.mirakl-offer-list').addClass('d-none');
              }
          }
      });
      if (miraklOffersJson.length <= 0) {
          $('.get-offer-list').addClass('d-none');
      }
  } else {
      $('.mirakl-offer-list').addClass('d-none');
  }
}

/**
 * Updates the buybox and load offers when a variant is changed
 * @param {Object} response - The response from the ajax call(Product-Variant)
 */
function updateBuyBox(response) {
    if (response.data && response.data.isMiraklEnabled) {
        $('.pdp-buybox')
            .empty()
            .html(response.data.buyboxHtml);
        if (response.data.callP11) {
            if (response.data.useOffer) {
                $('.attribute.quantity').addClass('d-none');
            } else {
                $('.attribute.quantity').removeClass('d-none');
            }
            var localeParts = response.data.locale.split('_');
            var selectedCountry = localeParts.length > 1 ? localeParts[1].toUpperCase() : null;
            if (selectedCountry != null && selectedCountry == "US") {
              loadMiraklOffers.loadMiraklOffers();
            }
        } else {
            $('.attribute.quantity').removeClass('d-none');
            $('.mirakl-offer-list').addClass('d-none');
            $('.mirakl-offer-list').empty();
        }
    }
}

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
  $('button.add-to-cart-global, button.add-to-cart').attr('disabled', enableOrDisable);
}

/**
 * @description Initialize the product sliders
 */
function waitForElementToDisplay1() {
  if ($('.product-detail .product-recommendations  div[id^="cq"]').length) {
    $('.product-detail .product-recommendations').removeClass('no-recs');
    if ($('.product-detail .product-recommendations div[id^="cq"] .recommendation-item').length > 1) {
      // initSliders1();
    } else {
      interID = setTimeout(waitForElementToDisplay1, 10);
      if (varCounter <= 7000) {
        varCounter++;
      } else {
        clearTimeout(interID);
      }
    }
  } else {
    clearTimeout(interID);
    $('.product-detail .product-recommendations').addClass('no-recs');
  }
}

/**
 * Validate whole physical gift card form, to check if form is invalid or valid.Flag to indicate if form is valid then make button enabled
 * @param {string=} id - form id's name.
 */
function validatePhysicalGiftForm(id) {
  var valid = $(id)[0].checkValidity();
  if (valid) {
    if ($('#dwfrm_giftcardelectronic').length > 0) {
      var recaptcha = $('#g-recaptcha-response').val().length > 0;
      var validateOccasionAndAmount = $('.select-styles').length === 0;
      if (recaptcha && validateOccasionAndAmount) {
        $(id).closest('.product-detail').find('.add-to-cart button, button.add-to-cart-egift').prop('disabled', false);
      } else {
        $(id).closest('.product-detail').find('.add-to-cart button, button.add-to-cart-egift').prop('disabled', 'disabled');
      }
    } else {
      $(id).closest('.product-detail').find('.add-to-cart button, button.add-to-cart-egift').prop('disabled', false);
    }
  } else {
    $(id).closest('.product-detail').find('.add-to-cart button, button.add-to-cart-egift').prop('disabled', 'disabled');
  }
}

function isGiftFormValid(id) {
  var valid = $(id)[0].checkValidity();
  if (valid) {
    if ($('#dwfrm_giftcardelectronic').length > 0) {
      var recaptchaStatus = $('#g-recaptcha-response').val().length > 0;
      var validateOccasionAndAmount = $('.select-styles').length === 0;
      if (recaptchaStatus && validateOccasionAndAmount) {
        return true;
      }
      return false;
    }
    return true;
  }
  return false;
}

function loadMiraklDataForSingleVariants() {
  var colorVariationElement = $('[data-attr="color"] .color-attribute');
  var sizeVariationElement = $('[data-attr="size"] .size-attribute.color-attribute');
  var miraklOffersJsonElement = $('.js-mirakl-offers-json');
  if (colorVariationElement.length != 1 || sizeVariationElement.length != 1 || !miraklOffersJsonElement.length || !sizeVariationElement.data('url') || sizeVariationElement.closest('.product-detail').length != 1 || !base || !base.attributeSelect) {
      return;
  }

  var url = sizeVariationElement.data('url');
  var productContainer = sizeVariationElement.closest('.product-detail');
  base.attributeSelect(url, productContainer);
}

window.addEventListener('load', function (event) {
  var zoomImages = document.querySelectorAll('img[role="presentation"].zoomImg');
  var regularImages = document.querySelectorAll('img.carousel-image');

  zoomImages.forEach(function (zoomImage, index) {
    zoomImage.alt = regularImages[index].alt + ' - image with zoom';
  });
  powerReview.checkPowerReviewAvailability();
});

module.exports = {
  methods: {
    updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements,
    waitForElementToDisplay1: waitForElementToDisplay1
  },

  availability: base.availability,

  addToCart: base.addToCart,

  updateAttributesAndDetails: function () {
    $('body').on('product:statusUpdate', function (e, data) {
      var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

      $productContainer.find('.description-and-detail .product-attributes')
        .empty()
        .html(data.attributesHtml);

      if (data.shortDescription) {
        $productContainer.find('.description-and-detail .description')
          .removeClass('hidden-xl-down');
        $productContainer.find('.description-and-detail .description .content')
          .empty()
          .html(data.shortDescription);
      }
      if (data.longDescription) {
        $productContainer.find('.description-and-detail .details .content')
          .empty()
          .html(data.longDescription);
      }
    });
  },

  showSpinner: function () {
    $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
      $.spinner().start();
    });
  },
  updateAttribute: function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
      if ($('.product-detail>.bundle-items').length) {
        response.container.data('pid', response.data.product.id);
      } else if ($('.product-set-detail').eq(0)) {
        response.container.data('pid', response.data.product.id);
        response.container.find('.product-id').data('sku-id', response.data.product.id);
        updateBuyBox(response);
      } else {
        $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
        $('.product-id').text(response.data.product.id);
        $('.product-detail:not(".bundle-item")')
          .data(
            'pid',
            response.data.product.id
          );
      }
    });
  },
  updateAddToCart: function () {
    $('body').on('product:updateAddToCart', function (e, response) {
      var productsAvailable = $('.product-availability').toArray().every(function (item) {
        return $(item).data('available') && $(item).data('ready-to-order');
      });
      var errors = $('.select-styles, .quantity-error.d-block, .third-party-not-available').length > 0;
      if ($('button.add-to-cart, button.add-to-cart-egift').closest('.gift-pdp').length) {
        if (response.product.readyToOrder && response.product.available) {
          $('.gift-pdp').attr('data-available', true);
        }
        if (isGiftFormValid($('button.add-to-cart, button.add-to-cart-egift').closest('form')) && response.product.readyToOrder && response.product.available) {
          $('button.add-to-cart, button.add-to-cart-egift').prop('disabled', false);
        } else {
          $('button.add-to-cart, button.add-to-cart-egift').prop('disabled', true);
        }
      } else {
        // update local add to cart (for sets)
        $('button.add-to-cart', response.$productContainer).attr('disabled',
          (!response.product.readyToOrder || !response.product.available));
      }
      module.exports.methods.updateAddToCartEnableDisableOtherElements(!productsAvailable || errors);
    });
  },
  updateAvailability: function () {
    $('body').on('product:updateAvailability', function (e, response) {
      $('div.availability', response.$productContainer)
        .data('ready-to-order', response.product.readyToOrder)
        .data('available', response.product.available);

      $('.availability-msg', response.$productContainer)
        .empty().html();

      var $productDetails = $('.product-detail');
      var isGCProduct = $productDetails && $productDetails.length && $productDetails.hasClass('gift-pdp');

      if (isGCProduct && response.message.includes(window.Resources.IN_STOCK)) {
        $('.availability-msg').empty();
      }

      if ($('.global-availability').length) {
        var allAvailable = $('.product-availability').toArray()
          .every(function (item) { return $(item).data('available'); });

        var allReady = $('.product-availability').toArray()
          .every(function (item) { return $(item).data('ready-to-order'); });

        $('.global-availability')
          .data('ready-to-order', allReady)
          .data('available', allAvailable);

        $('.global-availability .availability-msg').empty()
          .html(allReady ? response.message : response.resources.info_selectforstock);
      }
    });
  },
  sizeChart: function () {
    $('.size-chart button').on('click', function (e) {
      e.preventDefault();
      var url = $(this).attr('href');
      var $prodSizeChart = $('.size-chart-modal .modal-body');
      if ($prodSizeChart.is(':empty') || $('.product-set-detail').length) {
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'html',
          success: function (response) {
            $prodSizeChart.html(JSON.parse(response).content);
            $('#sizechart-modal').modal('show');
            customerservice.init();
          },
          error: function () {
            $('#sizechart-modal').remove();
          }
        });
      } else {
        $('#sizechart-modal').modal('show');
        customerservice.init();
      }
    });

    var $sizeChart = $('.size-chart-collapsible');
    $('body').on('click touchstart', function (e) {
      if ($('.size-chart').has(e.target).length <= 0) {
        $sizeChart.removeClass('active');
      }
    });
  },
  copyProductLink: function () {
    $('body').on('click', '#fa-link', function () {
      event.preventDefault();
      var $temp = $('<input>');
      $('body').append($temp);
      $temp.val($('#shareUrl').val()).select();
      document.execCommand('copy');
      $temp.remove();
      $('.copy-link-message').attr('role', 'alert');
      $('.copy-link-message').removeClass('d-none');
      setTimeout(function () {
        $('.copy-link-message').addClass('d-none');
      }, 3000);
    });
  },

  charLimit: function () {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];
    $('body')
      .on(
        'keydown',
        'textarea[data-character-limit]',
        function (e) {
              var text = $.trim($(this).val()),
                charsLimit = $(this).data(
                        'character-limit'),
                charsUsed = text.length;

          if ((charsUsed >= charsLimit)
                        && (controlKeys.indexOf(e.which.toString()) < 0)) {
            e.preventDefault();
          }
        })
      .on(
        'change keyup mouseup',
        'textarea[data-character-limit]',
        function () {
              var text = $.trim($(this).val()),
                charsLimit = $(this).data(
                        'character-limit'),
                charsUsed = text.length,
                charsRemain = charsLimit
                        - charsUsed;

          if (charsRemain < 0) {
            $(this).val(text.slice(0, charsRemain));
            charsRemain = 0;
          }

          if (charsRemain == 0) {
            $(this).parent().find('.char-count').addClass('limit-reached');
          } else {
            $(this).parent().find('.char-count').removeClass('limit-reached');
          }

          $(this).parent().find('.char-count .char-remain-count').html(charsRemain);
        });
  },

  productOutfit: function () {
    // when click on outfit link, move down to complete the look section
    $('.outfit-this-item .badge-image').on('click', function (e) {
      var pos = $('.product-complete-the-look').offset();
      $('html,body').animate({ scrollTop: pos.top - 300 });
      e.preventDefault();
    });
  },

  physicalGiftButtonEnable: function () {
    $('form#dwfrm_giftcardphysical, #dwfrm_giftcardelectronic').on('keyup change select blur', 'input:visible', function () {
      if ($('button.add-to-cart, button.add-to-cart-egift').closest('.gift-pdp').data('available')) {
        var isInValidShip = false;
        $('form#dwfrm_giftcardphysicalg input:required, #dwfrm_giftcardelectronic input:required').each(function () {
          if ($(this).val() == '') {
            isInValidShip = true;
          }
        });
        if (isInValidShip) {
          $('form#dwfrm_giftcardphysical, #dwfrm_giftcardelectronic').closest('.product-detail').find('.add-to-cart button, button.add-to-cart-egift').prop('disabled', 'disabled');
        } else {
          validatePhysicalGiftForm('form#dwfrm_giftcardphysical, #dwfrm_giftcardelectronic');
        }
      }
    });
  },

  focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

  recaptcha: function () {
    if ($('#dwfrm_giftcardelectronic').length > 0) {
      window.addEventListener('load', function () {
        $('.recaptcha').append($('<div id="captcha_container" class="google-captcha"></div>'));
        grecaptcha.render('captcha_container', {
          sitekey: sitekey,
          callback: function (response) {
            validatePhysicalGiftForm($('#dwfrm_giftcardelectronic'));
          },
          'expired-callback': function () {
            validatePhysicalGiftForm($('#dwfrm_giftcardelectronic'));
          }
        });
      });
    }
  }
};
